function initialState() {
	return {
		allSpaces: [
			{
				id: 0,
				title: 'My Space',
				nodes: [
				],
				links: []
			}
		]
	};
}

export default {
	state: initialState,
	getters: {
		allSpaces: state => state.allSpaces
	},

	mutations: {
		saveSpace(state, spaceObj) {
			let spaceIndex = null;
			let objectExists = state.allSpaces.filter(function (el, index) {
				if (el.id == spaceObj.id) { spaceIndex = index; }
				return el.id == spaceObj.id;
			})[0];
			if (objectExists) {
				state.allSpaces.splice(spaceIndex, 1, spaceObj);
			} else {
				state.allSpaces.push(spaceObj);
			}
		},

		deleteSpace(state, spaceObj) {
			let spaceIndex = null;
			let objectExists = state.allSpaces.filter(function (el, index) {
				if (el.id == spaceObj.id) { spaceIndex = index; }
				return el.id == spaceObj.id;
			})[0];
			if (objectExists) {
				state.allSpaces.splice(spaceIndex, 1);
			}
		},

		resetAllSpaces(state) {
			Object.assign(state, initialState());
		}
	},

	actions: {
		saveSpace({ commit }, payload) {
			return new Promise((resolve, reject) => {
				commit('saveSpace', payload.spaceObj);
				resolve();
			});
		},

		deleteSpace({ commit }, payload) {
			return new Promise((resolve, reject) => {
				commit('deleteSpace', payload.spaceObj);
				resolve();
			});
		},

		resetAllSpaces({ commit }) {
			return new Promise((resolve, reject) => {
				commit('resetAllSpaces');
				resolve();
			});
		}
	}
}